import { combineReducers } from 'redux-immutable';

import billingReducer from './modules/billing/reducer'
import customerReducer from './modules/customer/reducer'
import emptySimsReducer from './modules/emptySims/reducer'
import forgotPasswordReducer from './modules/forgotPassword/reducer'
import globalReducer from './modules/global/reducer'
import simCardsReducer from './modules/simCards/reducer'
import simsReducer from './modules/sims/reducer'
import usageReducer from './modules/usage/reducer'

import { RESET_APPLICATION_STATE } from './modules/global/constants'

const appReducer = combineReducers({
	global: globalReducer,
	billing: billingReducer,
	customer: customerReducer,
	emptySims: emptySimsReducer,
	forgotPassword: forgotPasswordReducer,
	simCards: simCardsReducer,
	sims: simsReducer,
	usage: usageReducer
});

export const rootReducer = (state, action) => {
	// all reducers are cleared to initial if when we pass undefined as base state
	const appReducerState = (action.type !== RESET_APPLICATION_STATE) ? state : undefined;
	return appReducer(appReducerState, action)
};
